var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgPointer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 30,
    viewBox: "0 0 99 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.55555,
    cy: 14.5556,
    r: 5.55555,
    fill: "#22262F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.2291 15.9556C99.0001 15.1846 99.0001 13.9345 98.2291 13.1635L85.6648 0.599244C84.8938 -0.171763 83.6438 -0.171763 82.8727 0.599244C82.1017 1.37025 82.1017 2.6203 82.8727 3.39131L94.041 14.5596L82.8727 25.7278C82.1017 26.4988 82.1017 27.7489 82.8727 28.5199C83.6438 29.2909 84.8938 29.2909 85.6648 28.5199L98.2291 15.9556ZM6 16.5339L96.8331 16.5339V12.5853L6 12.5853V16.5339Z",
    fill: "#22262F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgPointer);
export default __webpack_public_path__ + "static/media/SvgPointer.ed5c28386372d1be6d7dcf7176c42d37.svg";
export { ForwardRef as ReactComponent };